import { render, staticRenderFns } from "./postWarning.vue?vue&type=template&id=319cb0c9&scoped=true&"
import script from "./postWarning.vue?vue&type=script&lang=js&"
export * from "./postWarning.vue?vue&type=script&lang=js&"
import style1 from "./postWarning.vue?vue&type=style&index=1&id=319cb0c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319cb0c9",
  null
  
)

export default component.exports